/**
 * Module commun bdc
 * @module app.bdc.common
 */
define([
    'angular',
    'modules/bdc/common/controllers/indexCtrl',
    'modules/bdc/common/factories/commonService',
    'modules/bdc/common/factories/flashupService',
    'modules/bdc/common/factories/marketService',
    'modules/bdc/common/factories/orderTypeService',
    'modules/bdc/common/factories/boulangerieService',
    'modules/bdc/common/factories/tillPackService',
    'modules/bdc/common/factories/multiStoresService',
    'modules/bdc/common/factories/storesGroupProvider',
    'modules/bdc/common/factories/userService',
    'modules/bdc/common/factories/userBackendProvider',
    'modules/bdc/common/factories/emailService',
    'modules/bdc/common/factories/emailProvider',
    'modules/bdc/common/factories/goodwillGesturesService',
    'modules/bdc/common/factories/commissionService',
    'modules/bdc/common/factories/marginService',
    'modules/bdc/common/factories/ladditionService',
    'modules/bdc/common/factories/napService',
    'modules/bdc/common/factories/offerService',
    'modules/bdc/common/factories/tpeService',
    'modules/bdc/common/factories/fleuristeService',
    'modules/bdc/common/factories/contractTypeService',
    'modules/bdc/common/factories/scenarioTypeService',
    'modules/bdc/common/factories/storeTypeService',
    'modules/bdc/common/factories/promotionService',
    'modules/bdc/common/factories/x3IntegrationStatusService',
    'modules/bdc/common/factories/eulerProvider',
    'modules/bdc/common/factories/eulerService',
    'modules/bdc/common/factories/csvService'
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function bdcCommonRouter($routeProvider) {
        $routeProvider.when('/', {
            redirectTo: '/portal/',
            params: {
                menuTitle: 'Portail'
            }
        });
        $routeProvider.otherwise({
            redirectTo: '/',
            params: {
                menuTitle: 'Portail'
            }
        });
    }

    bdcCommonRouter.$inject = ['$routeProvider'];

    /**
     * Configure indexedDB
     * @param $indexedDBProvider
     */
    function bdcCommonDB($indexedDBProvider) {
        $indexedDBProvider.connection('crm').upgradeDatabase(1, function(event, db, tx) {
            var objOrder = db.createObjectStore('Orders', {
                keyPath: '_id'
            });

            var objClient = db.createObjectStore('Clients', {
                keyPath: '_id'
            });

            objClient.createIndex('lastName_idx', 'lastName', {
                unique: false
            });

            var objStore = db.createObjectStore('Stores', {
                keyPath: 'identifiant_magasin'
            });
            objStore.createIndex('identifiant_magasin_idx', 'identifiant_magasin', {
                unique: true
            });

            var objWallet = db.createObjectStore('Wallets', {
                keyPath: '_id'
            });
        });
    }

    bdcCommonDB.$inject = ['$indexedDBProvider'];

    angular
        .module('app.bdc.common', [
            'app.bdc.common.indexCtrl',
            'app.bdc.common.commonService',
            'app.bdc.common.flashupService',
            'app.bdc.common.marketService',
            'app.bdc.common.orderTypeService',
            'app.bdc.common.boulangerieService',
            'app.bdc.common.tillPackService',
            'app.bdc.common.multiStoresService',
            'app.bdc.common.storesGroupProvider',
            'app.bdc.common.userService',
            'app.bdc.common.userBackendProvider',
            'app.bdc.common.emailService',
            'app.bdc.common.emailProvider',
            'app.bdc.common.goodwillGesturesService',
            'app.bdc.common.commissionService',
            'app.bdc.common.marginService',
            'app.bdc.common.ladditionService',
            'app.bdc.common.fleuristeService',
            'app.bdc.common.napService',
            'app.bdc.common.offerService',
            'app.bdc.common.tpeService',
            'app.bdc.common.contractTypeService',
            'app.bdc.common.scenarioTypeService',
            'app.bdc.common.storeTypeService',
            'app.bdc.common.promotionService',
            'app.bdc.common.x3IntegrationStatusService',
            'app.bdc.common.eulerProvider',
            'app.bdc.common.eulerService',
            'app.bdc.common.csvService'
        ])
        .config(bdcCommonRouter)
        .config(bdcCommonDB);
});
